@if (videoReviewers$ | async; as reviewers) {
  <div>
    @if (reviewers.length) {
      <div class="video-reviewers-list">
        <div class="table-headers">
          <div class="left-header guest-name-header" translate="common_user"></div>
          <div class="right-header" translate="common_email"></div>
        </div>
        <ul class="guest-list">
          @for (g of reviewers; track g) {
            <li class="list-item">
              <div class="guest-type-icon">
                @if (g.hasOwnProperty('uuid') && g.uuid !== null) {
                  <i class="ficon-app-email"
                    matTooltipPosition="above"
                  [matTooltip]="'session-editor-panel_invited-through-email' | translate"></i>
                }
                @if (g.uuid === null) {
                  <i class="ficon-app-link"
                    matTooltipPosition="above"
                  [matTooltip]="'session-editor-panel_invited-through-public-link' | translate"></i>
                }
                @if (!g.hasOwnProperty('uuid')) {
                  <i class="ficon-app-internal-reviewer"
                    matTooltipPosition="above"
                  [matTooltip]="'session-editor-panel_invited-internal-reviewer' | translate"></i>
                }
              </div>
              <div class="user-name">
                <span>{{ getUserName(g) }}</span>
                <div class="email-mobile">
                  <span class="email">{{getEmail(g)}}</span>
                  @if (!g.user_id) {
                    <span class="pending-guest">- pending</span>
                  }
                </div>
              </div>
              <div class="user-email">
                <span class="email"
                  [class]="{ 'pending-email': !g.user_id }"
                  matTooltipPosition="above"
                  [matTooltip]="getEmail(g)">
                  {{getEmail(g)}}
                </span>
                @if (!g.user_id) {
                  <span class="pending-guest">- pending</span>
                }
              </div>
              <div class="btn-none right-button">
                <button
                  type="button"
                  class="btn-none remove-guest-btn"
                  [attr.aria-label]="getDeleteAriaLabel(g)"
                  [matTooltip]="(g.user_id ? 'session-editor-panel_external-reviewers-delete' : 'group-settings_delete-invite') | translate"
                  matTooltipPosition="above"
                  (click)="removeGuest(g)">
                  <i class="ficon-app-x"></i>
                </button>
              </div>
            </li>
          }
        </ul>
      </div>
    }
  </div>
}

@if ((videoReviewers$ | async).length === 0) {
  <div class="empty-state-text">
    {{ 'session-editor-panel_guest-reviewers-empty-state' | translate }}
  </div>
}
